// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-dropdown-callout {
  padding: 0;
  max-width: 500px;
}
.color-dropdown-callout .bolt-list-cell {
  border-width: 0 !important;
}
.color-dropdown-callout .bolt-table-row {
  box-shadow: none !important;
}
.color-dropdown-callout .bolt-table-row .bolt-table-cell-content {
  padding: 0;
}
.color-dropdown-callout .color-dropdown-table-container {
  flex-grow: 0 !important;
  margin-bottom: 2px;
}
.color-dropdown-callout .color-button {
  border-radius: 0;
  border-width: 0;
  border-color: rgba( 255, 255, 255 ,  1 ) !important;
  border-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 ) !important;
  margin: 2px;
  height: 16px;
}

.color-dropdown .bolt-textfield .suffix {
  padding: 0px 4px;
  margin: 0px 7px;
}

.bolt-focus-visible .color-button:focus {
  border-width: 2px;
  height: 12px;
}

.color-callout {
  align-items: center;
  padding-bottom: 1px;
}
.color-callout .bolt-button.icon-only {
  padding: 0px;
  background-color: transparent;
}

.style-rule-font-color-bar {
  height: 4px;
  width: 20px;
  margin-top: -1px;
}

/*# sourceMappingURL=ColorPicker.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/ColorPicker/ColorPicker.scss","webpack://./../azure-devops-ui/bin/Components/ColorPicker/ColorPicker.css"],"names":[],"mappings":"AAOA;EACI,UAAA;EACA,gBAAA;ACNJ;ADQI;EACI,0BAAA;ACNR;ADSI;EACI,2BAAA;ACPR;ADQQ;EACI,UAAA;ACNZ;ADUI;EACI,uBAAA;EACA,kBAAA;ACRR;ADWI;EACI,gBAAA;EACA,eAAA;EACA,mDAAA;EACA,4EAAA;EACA,WA/BQ;ECsBd,YAAY;AACd;;AAEA;EDYI,gBAAA;ECVF,eAAe;AACjB;;AAEA;EDeY,iBAAA;ECbV,YAAY;AACd;;AAEA;EDiBI,mBAAA;ECfF,mBAAmB;ADgBjB;ACdJ;EDgBQ,YAAA;ECdN,6BAA6B;AAC/B;;AAEA;EDiBI,WAAA;EACA,WAAA;ECfF,gBAAgB;AAClB;;AAEA,0CAA0C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
